import { render } from "./basket_totals.vue?vue&type=template&id=593a9382"
import script from "./basket_totals.vue?vue&type=script&lang=js"
export * from "./basket_totals.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__